import axios from 'axios'  //这里引入axios  mian无需再引
import Vue from "vue";    //引入Vue
Vue.prototype.$ajax = axios;  //修改ajax原型指向为 axios
import Qs from 'qs';  // 引入Qs，这个库是axios里面包含的，不需要再下载了

import store from '@/store'

// const api = 'http://yyapitest.medinhealth.com/';

// 超时设定
axios.defaults.timeout = 15000;

axios.interceptors.request.use(config => {
    return config
}, err => {
    alert('请求超时');
    return Promise.resolve(err)
});

// http response 拦截器
axios.interceptors.response.use(response => {
    const data = response.data;
    return data
}, (err) => {
    // 返回状态码不为200时候的错误处理
    return Promise.resolve(err)
});

//封装axios
 const axiosPost = (url, data, type, headers, contentType, processData,async) => {
    if(type == null || type == undefined){
        type = "GET"
    }
    if(headers == null || headers == undefined){
        headers = {}
    }
    if(contentType == null || contentType == undefined){
        contentType = "application/x-www-form-urlencoded; charset=UTF-8"
    }
    if(processData == null || processData == undefined){
        processData = true
    }
    if(async == null || async == undefined){
        async = true
    }

    return axios({
        url: url,
        method:type,
        data: headers['Content-Type'] == 'application/json'?data:Qs.stringify(data),
        headers: Object.assign({'Content-Type': 'application/x-www-form-urlencoded'}, headers)
    })
};

// 获取天气信息 参数: 调用接口下标
export const getWeatherInfo = (index) => {
	var i = index?index:0;
	
	var apiList = [
		'https://v0.yiketianqi.com/api',
		'https://v1.yiketianqi.com/api',
		'https://v2.yiketianqi.com/api'
	];
	return axiosPost(apiList[i] + '?version=v61&vue=1&appid=68934367&appsecret=RDx781Yx');
	
}

// 健康频道
export const getHealth = () => {
	return axiosPost('https://api.medinbd.com/v1/article/list/', {}, 'post');
}


// 大禹
// 获取资讯列表 参数：current：当前页码  size：每页多少条
export const getHealthDy = (current, size) => {
	return axiosPost('https://dayu.inshm.com/weapp/wx/news/pages?current='+(current?current:1)+'&size='+(size?size:10), {}, 'get', {'X-DS-Token': 'aq6mvysgm5l2c4vyc0kvom9zet1np6jy'});
}
// 获取资讯列表详情
export const getHealthDyDetail = (id) => {
	return axiosPost('https://dayu.inshm.com/weapp/wx/news/detail?newsId='+id, {}, 'get', {'X-DS-Token': 'aq6mvysgm5l2c4vyc0kvom9zet1np6jy'});
}

// 在线咨询
// 提问
export const onlineAsk = (data) => {
	return axiosPost('https://dayu.inshm.com/weapp/wx/consult/createConsult', data, 'post', {'X-DS-Token': 'aq6mvysgm5l2c4vyc0kvom9zet1np6jy', 'Content-Type': 'application/json'});
}
// 详情
export const getOnlineDetail = (id) => {
	return axiosPost('https://dayu.inshm.com/weapp/wx/consult/consult/'+id, {}, 'get', {'X-DS-Token': 'aq6mvysgm5l2c4vyc0kvom9zet1np6jy'});
}

// 课程计划
// 课程列表 参数：current：当前页码  size：每页多少条
export const courseList = (current, size) => {
	return axiosPost('https://dayu.inshm.com/weapp/wx/news/courses?page='+(current?current:1)+'&size='+(size?size:10), {}, 'get', {'X-DS-Token': 'aq6mvysgm5l2c4vyc0kvom9zet1np6jy'});
}
// 课程详情
export const courseDetail = (courseId) => {
	return axiosPost('https://dayu.inshm.com/weapp/wx/news/course/detail?courseId='+courseId, {}, 'get', {'X-DS-Token': 'aq6mvysgm5l2c4vyc0kvom9zet1np6jy'});
}


//米因研究
//列表
export const studyList = (data) => {
	return axiosPost('https://api.medinhealth.com/v1/article/list/',data,'post');
}
//詳情
export const studyDetail = (id) => {
	return axiosPost('https://api.medinhealth.com/v1/article/detail/' + id,{},'post');
}